import {
  IPlatformResourcesResponse,
  IPlatformResourceResponse,
  IPlatformTheme,
  IPlatformThemePayload
} from 'types/platformResources';
import request from './index';

export const getPlatformThemes = (practiceId: number) =>
  request<IPlatformResourcesResponse<IPlatformTheme>>({
    options: {
      url: `/platform/resources/practices/${practiceId}/themes`,
      method: 'get'
    }
  });

export const createPlatformTheme = (practiceId: number, data: IPlatformThemePayload) =>
  request<IPlatformResourceResponse<IPlatformTheme>>({
    options: {
      url: `/platform/resources/practices/${practiceId}/themes`,
      method: 'post',
      data
    }
  });

export const editPlatformTheme = (id: number, data: IPlatformThemePayload) =>
  request<IPlatformResourceResponse<IPlatformTheme>>({
    options: { url: `/platform/resources/themes/${id}`, method: 'patch', data }
  });

export const deletePlatformTheme = (id: number) =>
  request<Record<string, never>>({
    options: { url: `/platform/resources/themes/${id}`, method: 'delete' }
  });
